var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 4.23529C9.6 3.06728 10.5567 2.11765 11.7333 2.11765C12.91 2.11765 13.8667 3.06728 13.8667 4.23529V5.29412C13.8667 5.87978 14.3433 6.35294 14.9333 6.35294C15.5233 6.35294 16 5.87978 16 5.29412V4.23529C16 1.89596 14.09 0 11.7333 0C9.37667 0 7.46667 1.89596 7.46667 4.23529V6.35294H2.13333C0.956667 6.35294 0 7.30257 0 8.47059V15.8824C0 17.0504 0.956667 18 2.13333 18H10.6667C11.8433 18 12.8 17.0504 12.8 15.8824V8.47059C12.8 7.30257 11.8433 6.35294 10.6667 6.35294H9.6V4.23529Z",
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.c137d2e1aab9efe0862743200ba8106e.svg";
export { ForwardRef as ReactComponent };